import React from "react";
import { GlassCard, Button, InputField, SelectField } from "../components/ui";
import RangeCalendarPicker from "../components/RangeCalendarPicker";
import { btn3d } from "../styles/buttonStyles";

export default function TravelPage({ darkMode, lang, setStep, itinerary, t, dm, travel, setTravel, companionType, setCompanionType, updateTravel, personal, error, travelError2, setTravelError2, generateItinerary }) {
  return (
            <div className="animate-in">
              <GlassCard>
                <h2 className="text-lg" style={{ fontFamily:"inherit", fontWeight:900, backgroundImage:dm?"linear-gradient(120deg,#A5B4FC,#C4B5FD)":"linear-gradient(120deg,#6366F1,#7C3AED)", WebkitBackgroundClip:"text", backgroundClip:"text", WebkitTextFillColor:"transparent", marginBottom:5, letterSpacing:"-0.02em" }}>{`✦ ${t.travelTitle}`}</h2>
                <p className="text-sm" style={{ color:dm?"rgba(226,232,240,0.74)":"rgba(51,65,85,0.74)", fontWeight:500, marginBottom:24, lineHeight:1.6 }}>{t.travelDesc}</p>
                <RangeCalendarPicker label="여행 날짜" startDate={travel.startDate} endDate={travel.endDate} onChange={({startDate,endDate})=>setTravel(t=>({...t,startDate,endDate}))} darkMode={darkMode}/>

                {/* 동반자 유형 */}
                <fieldset style={{ margin:0, marginBottom:18, padding:0, border:0, minWidth:0 }}>
                  <legend className="text-xs" style={{ display:"flex", alignItems:"center", gap:6, width:"100%", padding:0, fontWeight:700, letterSpacing:"0.1em", color:"var(--accent)", marginBottom:7, textTransform:"uppercase" }}>
                    여행 유형
                    <span className="text-xs" style={{ fontWeight:800, padding:"2px 6px", borderRadius:100, background:"rgba(74,154,90,0.12)", color:"#4a9a5a", border:"1px solid rgba(74,154,90,0.3)", letterSpacing:"0.05em", textTransform:"none", flexShrink:0 }}>선택</span>
                  </legend>
                  <p id="companion-type-help" className="text-xs" style={{ color:"var(--muted)", lineHeight:1.55, marginBottom:10 }}>
                    선택한 유형에 맞춰 장소·식당·일정 밀도가 실제 일정에 반영됩니다.
                  </p>
                  <div style={{ display:"grid", gridTemplateColumns:"repeat(2,minmax(0,1fr))", gap:9 }}>
                    {[
                      { val:"solo", label:"혼자여행", emoji:"🧍" },
                      { val:"couple", label:"커플여행", emoji:"👫" },
                      { val:"family", label:"가족여행", emoji:"👨‍👩‍👧" },
                      { val:"group", label:"단체여행", emoji:"👥" },
                    ].map(({ val, label, emoji }) => {
                      const selected = companionType === val;
                      return (
                        <button
                          key={val}
                          type="button"
                          onClick={() => setCompanionType(selected ? "" : val)}
                          aria-pressed={selected}
                          aria-describedby="companion-type-help"
                          className="btn3d"
                          style={{
                            ...btn3d(selected ? "primary" : "outline", dm),
                            minWidth:0,
                            minHeight:48,
                            padding:"10px 9px",
                            borderRadius:13,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"center",
                            gap:7,
                            fontWeight:800,
                          }}
                        >
                          <span aria-hidden="true" style={{ fontSize:18 }}>{emoji}</span>
                          <span className="text-xs">{selected ? `${label} · 선택됨` : label}</span>
                        </button>
                      );
                    })}
                  </div>
                  {!companionType && (
                    <p className="text-xs" style={{ marginTop:8, color:"var(--muted)", textAlign:"center" }}>선택하지 않아도 됩니다</p>
                  )}
                </fieldset>

                {/* 출발지 */}
                <div style={{ marginBottom:18 }}>
                  <label htmlFor="travel-departure" className="text-xs" style={{ display:"flex", alignItems:"center", gap:6, fontWeight:700, letterSpacing:"0.1em", color:"var(--accent)", marginBottom:7, textTransform:"uppercase" }}>
                    출발지
                    <span className="text-xs" style={{ fontWeight:800, padding:"2px 6px", borderRadius:100, background:"rgba(224,80,64,0.12)", color:"#E05040", border:"1px solid rgba(224,80,64,0.25)", letterSpacing:"0.05em", textTransform:"none", flexShrink:0 }}>필수</span>
                  </label>
                  <div style={{ position:"relative" }}>
                    <input
                      id="travel-departure"
                      type="text"
                      value={travel.departure}
                      onChange={e=>{ updateTravel("departure", e.target.value); }}
                      placeholder={personal.address || "출발 지역을 입력해주세요"}
                      className="text-base" style={{ width:"100%", padding:"16px 18px", background:dm?"rgba(255,255,255,0.13)":"rgba(255,255,255,0.88)", border:dm?"1.5px solid rgba(129,140,248,0.3)":"1.5px solid rgba(99,102,241,0.3)", borderRadius:16, color:travel.departure?dm?"#FFFFFF":"#0F172A":dm?"rgba(255,255,255,0.35)":"rgba(71,85,105,0.62)", fontWeight:travel.departure?700:400, fontFamily:"inherit", outline:"none", boxSizing:"border-box", transition:"border 0.2s, box-shadow 0.2s" }}
                      onFocus={e=>{e.target.style.borderColor="var(--accent)";e.target.style.boxShadow=dm?"0 0 0 3px rgba(129,140,248,0.15)":"0 0 0 3px rgba(99,102,241,0.12)";}}
                      onBlur={e=>{e.target.style.borderColor=dm?"rgba(129,140,248,0.3)":"rgba(99,102,241,0.3)";e.target.style.boxShadow="none";}}
                    />
                    {personal.address && !travel.departure && (
                      <div style={{ position:"absolute", right:10, top:"50%", transform:"translateY(-50%)" }}>
                        <button type="button" onClick={()=>updateTravel("departure", personal.address)}
                          className="btn3d text-xs" style={{ ...btn3d("outline", dm), padding:"4px 8px", minHeight:30, borderRadius:7, fontWeight:800, whiteSpace:"nowrap" }}>
                          {t.useAddress}
                        </button>
                      </div>
                    )}
                  </div>
                  {personal.address && !travel.departure && (
                    <p className="text-xs" style={{ color:dm?"rgba(226,232,240,0.70)":"rgba(51,65,85,0.65)", marginTop:5 }}>
                      📍 등록된 거주지: {personal.address}
                    </p>
                  )}
                </div>

                {/* 목적지 */}
                <InputField label="목적지" value={travel.destination} onChange={v=>updateTravel("destination",v)} placeholder="가고 싶은 지역을 입력해주세요" darkMode={darkMode} required={true}/>

                {/* 출발 시간 */}
                <fieldset style={{ margin:0, marginBottom:18, padding:0, border:0, minWidth:0 }}>
                  <legend className="text-xs" style={{ display:"flex", alignItems:"center", gap:6, width:"100%", padding:0, fontWeight:700, letterSpacing:"0.1em", color:"var(--accent)", marginBottom:7, textTransform:"uppercase" }}>
                    출발 시간
                    <span className="text-xs" style={{ fontWeight:800, padding:"2px 6px", borderRadius:100, background:"rgba(120,180,120,0.12)", color:"#4a9a5a", border:"1px solid rgba(120,180,120,0.3)", letterSpacing:"0.05em", textTransform:"none", flexShrink:0 }}>선택</span>
                  </legend>
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
                    {[{value:"이른 아침 (06:00~08:00)", icon:"🌅", label:"이른 아침", sub:"06:00~08:00"},{value:"오전 (09:00~11:00)", icon:"☀️", label:"오전", sub:"09:00~11:00"},{value:"점심 후 (12:00~14:00)", icon:"🌤️", label:"점심 후", sub:"12:00~14:00"},{value:"오후 (15:00~18:00)", icon:"🌇", label:"오후", sub:"15:00~18:00"}].map(opt=>(
                      <button key={opt.value} type="button" onClick={()=>updateTravel("departureTime", travel.departureTime===opt.value?"":opt.value)}
                        aria-pressed={travel.departureTime===opt.value}
                        className="btn3d"
                        style={{ ...btn3d(travel.departureTime===opt.value?"primary":"outline", dm), minWidth:0, padding:"12px 10px", borderRadius:14, display:"flex", alignItems:"center", gap:8, textAlign:"left" }}>
                        <span aria-hidden="true" className="text-lg" style={{ flexShrink:0 }}>{opt.icon}</span>
                        <div style={{ minWidth:0 }}>
                          <div className="text-sm" style={{ fontWeight:800 }}>{opt.label}</div>
                          <div className="text-xs" style={{ color:travel.departureTime===opt.value?"rgba(255,255,255,0.82)":"var(--muted)" }}>{opt.sub}</div>
                        </div>
                        {travel.departureTime===opt.value&&<span className="text-sm" style={{ marginLeft:"auto" }}>✓</span>}
                      </button>
                    ))}
                  </div>
                </fieldset>
                <SelectField label={t.styleLabel} value={travel.style} onChange={v=>updateTravel("style",v)} options={t.styles} placeholder={lang==="ko"?"여행 스타일 선택":"Select style"} darkMode={darkMode} required={true}/>
                <fieldset style={{ margin:0, marginBottom:18, padding:0, border:0, minWidth:0 }}>
                  <legend className="text-xs" style={{ display:"flex", alignItems:"center", gap:6, width:"100%", padding:0, fontWeight:700, letterSpacing:"0.1em", color:"var(--accent)", marginBottom:10, textTransform:"uppercase" }}>
                    {t.transportLabel}
                    <span className="text-xs" style={{ fontWeight:800, padding:"2px 6px", borderRadius:100, background:"rgba(224,80,64,0.12)", color:"#E05040", border:"1px solid rgba(224,80,64,0.25)", letterSpacing:"0.05em", textTransform:"none", flexShrink:0 }}>필수</span>
                  </legend>
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
                    {[{value:"자가용",icon:"🚗",title:"자가용",desc:"자유로운 드라이브"},{value:"대중교통",icon:"🚇",title:"대중교통",desc:"버스·지하철·기차"}].map(opt=>(
                      <button key={opt.value} type="button" onClick={()=>updateTravel("transport",opt.value)}
                        aria-pressed={travel.transport===opt.value}
                        className="btn3d"
                        style={{ ...btn3d(travel.transport===opt.value?"primary":"outline", dm), minWidth:0, padding:"16px 10px", borderRadius:15, textAlign:"center" }}>
                        <div aria-hidden="true" className="text-2xl" style={{ marginBottom:6 }}>{opt.icon}</div>
                        <div className="text-sm" style={{ fontWeight:800, marginBottom:2 }}>{opt.title}</div>
                        <div className="text-xs" style={{ color:travel.transport===opt.value?"rgba(255,255,255,0.82)":"var(--muted)" }}>{opt.desc}</div>
                        {travel.transport===opt.value&&<div className="text-xs" style={{ marginTop:5 }}>{t.selected}</div>}
                      </button>
                    ))}
                  </div>
                </fieldset>
{error&&<p role="alert" className="text-sm" style={{ color:"#C03020", marginBottom:14, textAlign:"center" }}>{error}</p>}
                <div>
                  {travelError2 && <p role="alert" className="text-sm" style={{ color:dm?"#FF8070":"#C03030", marginBottom:10, textAlign:"center", fontWeight:700 }}>{travelError2}</p>}
                  <div style={{ display:"flex", gap:10 }}>
                    <div style={{ flex:0.4 }}><Button darkMode={darkMode} secondary onClick={()=>setStep("personal")}>{t.prevBtn}</Button></div>
                    <div style={{ flex:0.6 }}><Button darkMode={darkMode} onClick={()=>{
                      const missing = [];
                      if(!travel.startDate) missing.push("출발일");
                      if(!travel.endDate) missing.push("도착일");
                      if(!travel.departure && !personal.address) missing.push("출발지");
                      if(!travel.destination) missing.push("목적지");
                      if(!travel.style) missing.push("여행 스타일");
                      if(!travel.transport) missing.push("이동 수단");
                      if(missing.length > 0) { setTravelError2("필수 입력: " + missing.join(", ")); return; }
                      setTravelError2("");
                      generateItinerary();
                    }}>{t.generateBtn}</Button></div>
                  </div>
                </div>
              </GlassCard>
            </div>
  );
}
